import { PRODUCT_BUSINESS_UNIT_KINDS_MAP } from 'pages/AuditLogs/constants';
import { FlatOption, ProductSelection } from 'pages/AuditLogs/types';

const isSelectionValidForProduct = (selection: FlatOption | null, productSelection: ProductSelection) => {
  if (!selection || !productSelection) {
    return true;
  }

  const validKinds = PRODUCT_BUSINESS_UNIT_KINDS_MAP[productSelection];
  if (!validKinds) {
    return true;
  }

  return validKinds.has(selection.kind);
};

export default isSelectionValidForProduct;
